import React from 'react';
import PropTypes from 'prop-types';
import NoteToggleAction from '../actions/NoteToggleAction';

export default class NoteDisplayBeat extends React.Component {
	static propTypes = {
		beat: PropTypes.number,
		bar: PropTypes.number,
		active: PropTypes.bool,
		notes: PropTypes.arrayOf(PropTypes.number)
	};

	static contextTypes = {
		executeAction: PropTypes.func.isRequired
	};

	constructor(props) {
		super(props);
	}



	render() {

		var beats = [], className;

		for (var i = 0; i < 14; i++) {
			className = "note" + (this.props.notes.indexOf(i) === -1 ?"":" active");
			beats.push(
				<div className={className} key={i} onClick={this.handleClick.bind(this, i)}></div>
			);
		}

		className = (this.props.active === true ?
			"active " : "") + "NoteDisplayBeat";


		return (
		    <div className={className}>
		    	{beats}
		    </div>
		);
	}

	handleClick(number, event) {
		this.context.executeAction(NoteToggleAction, {
			note: number,
			bar: this.props.bar,
			beat: this.props.beat
		});
	}
}
